<template>
    <v-card elevation="0" :loading="isLoadingObjetivos">
        <v-card-title>
            <v-row>
                <v-col md="12">
                    <h3 class="font-weight-light px-2">Tabla Bolsa</h3>
                </v-col>
            </v-row>
        </v-card-title>
        <!-- <v-divider class="test"></v-divider> -->
        <v-simple-table>
            <template v-slot:default>
                <tbody v-if="!isLoadingObjetivos">
                    <tr v-for="(key, clave) in filterLlaves" :key="clave" class="text-center">
                        <td :class="
                            clave == 'Rentabilidad'
                                ? 'font-weight-bold blue lighten-2'
                                : clave == 'Bolsa en Juego' &&
                                    (!bolsaComercial.reward || (!bolsaComercial.reward_recomendado && bolsaComercial.bolsa_recomendado != 0))
                                ? 'font-weight-bold red lighten-2'
                                : ''
                        ">
                            {{ clave }}
                        </td>
                        <td :class="
                            clave == 'Rentabilidad'
                                ? 'font-weight-bold blue lighten-2'
                                : clave == 'Bolsa en Juego' &&
                                    (!bolsaComercial.reward || (!bolsaComercial.reward_recomendado && bolsaComercial.bolsa_recomendado != 0))
                                ? 'font-weight-bold red lighten-2'
                                : ''
                        ">
                            {{ key }}
                        </td>
                    </tr>
                </tbody>
                <div v-else class="d-flex justify-center py-4" style="width:100% !important;">
                    <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </div>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { clone } from '@/util/libUtil.js';

export default {
    name: 'TablaBolsa',
    data: () => ({
        llaves: {
            'Bolsa en Juego': '0.00 €',
            'Bolsa Comercial': '0.00 €',
            'Bolsa Recomendado': '0.00 €',
            Consecucion: '0.0 %',
            Corrector: '0',
            'Total Comisión': '- €',
            // Rentabilidad: '0 €',
        },
    }),
    watch: {
        selectedComercial: {
            immediate: true,
            handler() {
                if (!this.selectedComercial)
                    this.llaves['Bolsa en Juego'] = `0.00 €`;
            },
        },
        getConsecucion: {
            immediate: true,
            handler(newValue, oldValue) {
                this.llaves['Consecucion'] = `${newValue} %`;
            },
        },
        getCorrector: {
            immediate: true,
            handler(newValue, oldValue) {
                this.llaves['Corrector'] = newValue;
            },
        },
        getBolsaEnJuego: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!isNaN(newValue)) {
                    this.llaves['Bolsa en Juego'] = `${
                        Math.floor(newValue * 100) / 100
                    } €`;
                } else {
                    this.llaves['Bolsa en Juego'] = 'Sin establecer';
                }
            },
        },
        getBolsaComercial: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!isNaN(newValue)) {
                    this.llaves['Bolsa Comercial'] = `${Math.floor(newValue * 100) / 100
                        } €`;
                } else {
                    this.llaves['Bolsa Comercial'] = 'Sin establecer';
                }
            },
        },
        getBolsaRecomendador: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!isNaN(newValue)) {
                    this.llaves['Bolsa Recomendado'] = `${Math.floor(newValue * 100) / 100
                        } €`;
                } else {
                    this.llaves['Bolsa Recomendado'] = 'Sin establecer';
                }
            },
        },
        getTotalComision: {
            immediate: true,
            handler(newValue, oldValue) {
                this.llaves['Total Comisión'] =
                    !isNaN(newValue) && newValue ? `${newValue} €` : `-`;
            },
        },
        getBolsaEnJuegoSinPorcentaje: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!isNaN(newValue) && this.haveCostoGeneral) {
                    this.llaves['Rentabilidad'] = `${(
                        Math.floor(newValue * 100) / 100 -
                        this.haveCostoGeneral
                    ).toFixed(2)} €`;
                } else {
                    delete this.llaves['Rentabilidad'];
                }
            },
        },
    },
    methods: {},
    computed: {
        filterLlaves() {
            let copyLlaves = clone(this.llaves);
            if (this.bolsaComercial.reward_recomendado == null) {
                delete copyLlaves['Bolsa Comercial'];
                delete copyLlaves['Bolsa Recomendado'];
            }
            if (!this.isComercialCobOrRec) {
                if (this.hasComercialPermission) {
                    delete copyLlaves['Rentabilidad'];
                    return copyLlaves
                }
            }

            // delete rentabilidad if not is admin or super
            if (!this.hasAdminPermission)
                delete copyLlaves['Rentabilidad'];
            return copyLlaves;
        },
        ...mapGetters('areaPersonal/calculadora', {
            getConsecucion: 'getConsecucion',
            getCorrector: 'getCorrector',
            getBolsaEnJuego: 'getBolsaEnJuego',
            getTotalComision: 'getTotalComision',
            getCostoGeneral: 'getCostoGeneral',
            getBolsaEnJuegoSinPorcentaje: 'getBolsaEnJuegoSinPorcentaje',
            haveCostoGeneral: 'haveCostoGeneral',
            getBolsaComercial: 'getBolsaComercial',
            getBolsaRecomendador: 'getBolsaRecomendador',
        }),
        ...mapGetters('login', {
            isComercialCobOrRec: 'isComercialCobOrRec',
            hasComercialPermission: 'hasComercialPermission',
            hasAdminPermission: 'hasAdminPermission',
        }),
        ...mapState('areaPersonal/calculadora', {
            selectedComercial: (state) => state.selectedComercial,
            isLoadingObjetivos: (state) => state.isLoadingObjetivos,
            bolsaComercial: (state) => state.bolsaComercial,
        }),
    },
};
</script>